import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { MapPin, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

export function SweepsList({ sweeps, currentSweep, onNavigate }) {
  if (!sweeps || sweeps.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-8 text-center">
        <MapPin className="h-8 w-8 text-muted-foreground mb-2" />
        <p className="text-sm text-muted-foreground">No positions available</p>
        <p className="text-xs text-muted-foreground/70 mt-1">Navigate in the viewer to discover positions</p>
      </div>
    );
  }

  // Filter to only enabled sweeps
  const enabledSweeps = sweeps.filter(sweep => sweep.enabled !== false);

  return (
    <div className="space-y-2 py-2">
      <p className="text-xs text-muted-foreground mb-3">
        {enabledSweeps.length} navigable positions
      </p>
      
      {enabledSweeps.slice(0, 20).map((sweep, index) => {
        const isCurrentSweep = currentSweep?.id === sweep.id;
        
        return (
          <Button
            key={sweep.id}
            variant="ghost"
            className={cn(
              "w-full justify-between h-auto py-3 px-3 text-left group",
              isCurrentSweep && "bg-primary/10 border border-primary/30"
            )}
            onClick={() => onNavigate(sweep.id)}
          >
            <div className="flex items-center gap-3 min-w-0">
              <div className={cn(
                "flex items-center justify-center w-8 h-8 rounded-lg text-xs font-mono",
                isCurrentSweep 
                  ? "bg-primary text-primary-foreground" 
                  : "bg-secondary text-secondary-foreground"
              )}>
                {index + 1}
              </div>
              <div className="min-w-0">
                <p className="text-sm font-medium truncate">
                  Position {index + 1}
                </p>
                <p className="text-xs text-muted-foreground font-mono truncate">
                  {sweep.id.substring(0, 12)}...
                </p>
              </div>
            </div>
            
            <div className="flex items-center gap-2">
              {isCurrentSweep && (
                <Badge variant="default" className="text-[10px]">
                  Current
                </Badge>
              )}
              <ChevronRight className={cn(
                "h-4 w-4 text-muted-foreground transition-transform",
                "group-hover:translate-x-1 group-hover:text-primary"
              )} />
            </div>
          </Button>
        );
      })}
      
      {enabledSweeps.length > 20 && (
        <p className="text-xs text-muted-foreground text-center pt-2">
          + {enabledSweeps.length - 20} more positions
        </p>
      )}
    </div>
  );
}

export default SweepsList;
